import React from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioKPICard = ({ title, value, change, changePercent, trend, icon, iconColor, isLoading, subtitle }) => {
  const formatValue = (val) => {
    if (typeof val === 'number') {
      if (title?.includes('Value') || title?.includes('PnL')) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })?.format(val);
      }
      return val?.toLocaleString();
    }
    return val;
  };

  const formatChange = (val) => {
    const sign = val > 0 ? '+' : '';
    return `${sign}${val?.toFixed(2)}%`;
  };

  const getChangeColor = () => {
    if (changePercent > 0) return 'text-success';
    if (changePercent < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (changePercent > 0) return 'TrendingUp';
    if (changePercent < 0) return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card rounded-[10px] p-4 md:p-6 lg:p-7 border border-border shadow-elevation-1 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-muted-foreground caption mb-1">{title}</p>
          {isLoading ? (
            <div className="h-8 md:h-10 bg-muted animate-pulse rounded-lg w-3/4"></div>
          ) : (
            <>
              <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground data-text truncate">
                {formatValue(value)}
              </h3>
              {subtitle && (
                <p className="text-xs text-muted-foreground caption mt-1">{subtitle}</p>
              )}
            </>
          )}
        </div>
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg bg-${iconColor}/10 flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={20} color={`var(--color-${iconColor})`} />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon name={getTrendIcon()} size={14} className={getChangeColor()} />
          <span className={`text-xs md:text-sm font-medium data-text ${getChangeColor()}`}>
            {formatChange(changePercent)}
          </span>
        </div>
        <span className="text-xs text-muted-foreground caption">24h</span>
      </div>
      {trend && trend?.length > 0 && (
        <div className="mt-3 md:mt-4 h-12 md:h-16">
          <svg className="w-full h-full" viewBox="0 0 200 60" preserveAspectRatio="none">
            <defs>
              <linearGradient id={`gradient-${title}`} x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor={changePercent > 0 ? 'var(--color-success)' : 'var(--color-error)'} stopOpacity="0.3" />
                <stop offset="100%" stopColor={changePercent > 0 ? 'var(--color-success)' : 'var(--color-error)'} stopOpacity="0" />
              </linearGradient>
            </defs>
            <path
              d={`M 0 ${60 - trend?.[0]} ${trend?.map((point, i) => `L ${(i / (trend?.length - 1)) * 200} ${60 - point}`)?.join(' ')} L 200 60 L 0 60 Z`}
              fill={`url(#gradient-${title})`}
            />
            <path
              d={`M 0 ${60 - trend?.[0]} ${trend?.map((point, i) => `L ${(i / (trend?.length - 1)) * 200} ${60 - point}`)?.join(' ')}`}
              fill="none"
              stroke={changePercent > 0 ? 'var(--color-success)' : 'var(--color-error)'}
              strokeWidth="2"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default PortfolioKPICard;